// components/MultiPlatformPixelScript/snackPixel.ts — Snack Video (snaptr) pixel firing
import type { FireContext } from './types';
import { makeEmbedSkipper } from '../../utils/embedTracking';
import { mapPlatformEvent } from './eventMaps';

export function fireSnackPixels(ctx: FireContext): void {
    const { configs, logPrefix, contentName, orderData, value, fireWithRetry, embedded, embedMode } = ctx;
    const skip = makeEmbedSkipper(embedded, embedMode, logPrefix);

    const snackConfigs = configs.filter(c => c.platform === 'snack');
    if (snackConfigs.length > 0) {
        if (typeof (window as any).snaptr === 'undefined') {
            (function(e,t,n){if((e as any).snaptr)return;var a=(e as any).snaptr=function()
            {(a as any).handleRequest?(a as any).handleRequest.apply(a,arguments):(a as any).queue.push(arguments)};
            (a as any).queue=[];var s='script';var r=t.createElement(s) as HTMLScriptElement;r.async=true;
            r.src=n;var u=t.getElementsByTagName(s)[0];
            u.parentNode!.insertBefore(r,u);})(window,document,
            'https://sc-static.net/scevent.min.js');
            console.log(`[${logPrefix} Snack] Injected base SDK`);
        }

        const snackEventName = snackConfigs[0].eventName;
        fireWithRetry(
            'Snack',
            snackEventName,
            () => typeof (window as any).snaptr === 'function',
            () => {
                const snaptr = (window as any).snaptr;

                snackConfigs.forEach(config => {
                    if (skip('Snack', config.eventName)) return;
                    try {
                        const params: any = {
                            content_name: contentName || 'Form',
                            currency: orderData?.currency || 'IDR'
                        };

                        if (orderData) {
                            params.price = orderData.value;
                            params.transaction_id = orderData.orderId;
                        } else if (value !== undefined) {
                            params.price = value;
                        }

                        const snackEvent = mapPlatformEvent('snack', config.eventName);

                        snaptr('track', snackEvent, params);
                        console.log(`[${logPrefix} Snack] ${snackEvent} FIRED!`);
                    } catch (e) {
                        console.error(`[${logPrefix} Snack] Error:`, e);
                    }
                });
            }
        );
    }
}
